export const NewsListComponent = {
	bindings: {
		news: '<',
		type: '='
	},
	templateUrl: 'news-list.html',
	controller: class NewsListComponent {
		constructor() {
			'ngInject';
			this.newsList = [];
		}

		$onChanges(changes) {
			if (changes.news) {
				this.initData = angular.copy(this.news);
				if (this.initData && this.type == 'news-list') {
					this.newsList = this.initData.content;
				} else if (this.initData && this.type == 'home') {
					this.newsList = this.initData;
				}
			}
		}

		clickOnReadLink($event, item) {
			$event.preventDefault();
			$event.stopPropagation();
			setTimeout(() => {
				window.location.href = '/hirek/' + item.url;
			}, 500);
		}

		clickOnReadAll($event) {
			$event.preventDefault();
			$event.stopPropagation();
			setTimeout(() => {
				window.location.href = angular.element($event.target).attr('href');
			}, 500);
		}
	}
};
